<!--
    BD Escalation Dialog — Wave 4.3
    p-dialog mit Eskalations-Typ-Auswahl und Pflicht-Begruendung.
    Mapping: WRITE_OFF -> action='WRITE_OFF', alles andere -> action='HANDOVER'.
    @ticket TM-1000001782
-->
@if (initialized) {
    <p-dialog
            [(visible)]="visible"
            [modal]="true"
            [closable]="true"
            [closeOnEscape]="true"
            [dismissableMask]="false"
            [style]="{width: '36rem'}"
            header="Eskalation"
            (visibleChange)="onVisibleChange($event)">

        <div class="flex flex-column gap-3 p-2">

            <!-- Mahnungs-Info -->
            <div class="surface-card border-round p-3 flex flex-column gap-2">
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-user text-primary"></i>
                    <span class="font-semibold">Kunde:</span>
                    <span>{{ customerName }}</span>
                </div>
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-file-lines text-primary"></i>
                    <span class="font-semibold">Mahn-Typ:</span>
                    <span>{{ dunningTypeName }}</span>
                </div>
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-layer-group text-primary"></i>
                    <span class="font-semibold">Aktive Stufe:</span>
                    <span>{{ activeLevelLabel }}</span>
                </div>
            </div>

            <!-- Hinweis -->
            <p-message
                    severity="warn"
                    text="Die Mahnung wird nun eskaliert. Bitte Typ und Begründung sorgfältig wählen."
                    styleClass="w-full">
            </p-message>

            <!-- Eskalations-Typ -->
            <div class="flex flex-column gap-1">
                <label class="block text-sm font-medium">
                    Eskalations-Typ <span class="text-red-500">*</span>
                </label>
                <p-select
                        [options]="typeOptions"
                        optionLabel="label"
                        optionValue="value"
                        [(ngModel)]="selectedType"
                        placeholder="Bitte wählen…"
                        appendTo="body"
                        styleClass="w-full">
                </p-select>
            </div>

            <!-- Begruendung -->
            <div class="flex flex-column gap-1">
                <label class="block text-sm font-medium">
                    Begründung <span class="text-red-500">*</span>
                </label>
                <textarea
                        pTextarea
                        rows="4"
                        [(ngModel)]="comment"
                        placeholder="Bitte die Eskalation ausführlich begründen…"
                        class="w-full">
                </textarea>
            </div>

            <!-- Error -->
            @if (errorMessage) {
                <p-message
                        severity="error"
                        [text]="errorMessage"
                        styleClass="w-full">
                </p-message>
            }
        </div>

        <!-- Footer -->
        <ng-template #footer>
            <div class="flex justify-content-end gap-2 w-full">
                <p-button
                        label="Abbrechen"
                        severity="secondary"
                        [disabled]="submitting"
                        (onClick)="onCancel()">
                </p-button>
                <p-button
                        label="Eskalation bestätigen"
                        icon="fa-regular fa-triangle-exclamation"
                        severity="warn"
                        [loading]="submitting"
                        [disabled]="selectedType === null"
                        (onClick)="confirm()">
                </p-button>
            </div>
        </ng-template>
    </p-dialog>
}
